import type { HeroForm } from './types';

// Keep original animation IDs for playback; only normalize display and order.
export function orderedActions(actions: HeroForm['actions']): HeroForm['actions'] {
  const basic: Record<string, [string, number]> = {
    wait: ['待机', 0], idle: ['待机', 0], stand: ['待机', 0],
    walk: ['移动', 1], run: ['移动', 1], move: ['移动', 1],
    att: ['攻击', 2], attack: ['攻击', 2],
  };
  return actions.map(action => {
    const id = action.id.toLowerCase();
    const skill = /^skill(\d+)$/.exec(id);
    const [label, order] = basic[id] ?? (skill ? [`技能${Number(skill[1])}`, 3 + Number(skill[1])] as const : [action.label, 1000]);
    return { id: action.id, label, order };
  }).sort((a, b) => a.order - b.order).map(({ id, label }) => ({ id, label }));
}
